module.exports = __webpack_public_path__ + "dcf774d20e3130370430974bdddf04a3.svg";